export default "__VITE_ASSET__CwIWtkfc__"